/**
 * Détecte si le code s'exécute dans un iframe
 * @return {boolean} true si dans un iframe, false sinon
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
